"use client";

import { clsx } from "@trydig/ui";
import { CartNotification } from "~/components/ui/CartNotification/CartNotification";
import { CartItems } from "~/features/cart/CartItems";
import { CartSummary } from "~/features/cart/CartSummary";
import { missingYarnsCount } from "~/lib/centra/utils/missingYarnsCount";
import { useCart } from "~/lib/hooks/useCart";
import styles from "./Cart.module.css";

export const CartContent = () => {
	const { totalQuantity, groupItems } = useCart();

	const missingRecipes = missingYarnsCount(groupItems);

	// useEffect(() => {
	// 	if (
	// 		modal.isOpen &&
	// 		selection?.selection?.items &&
	// 		selection?.selection?.currency
	// 	) {
	// 		const items = selectionItemsToGTMProducts({
	// 			items: selection.selection.items,
	// 			currency: selection.selection.currency,
	// 		});

	// 		gtm.viewCart({
	// 			items,
	// 			currency: selection.selection.currency,
	// 			value: items?.reduce((a, b) => (a + b.price) * (b.quantity || 1), 0),
	// 		});
	// 	}
	// }, [
	// 	modal.isOpen,
	// 	selection?.selection?.currency,
	// 	selection?.selection?.items,
	// ]);

	return (
		<div className={clsx(styles["cart-content"])}>
			<CartItems />
			{totalQuantity && totalQuantity > 0 && (
				<CartSummary
					missingYarns={missingRecipes.isMissing}
					labels={
						<CartNotification
							type="error"
							message={`${missingRecipes.text}`}
							show={missingRecipes.isMissing}
						/>
					}
				/>
			)}
		</div>
	);
};
